import { gql } from '@/shared/graphql/generated/reporting';

export const getDelegatorBalanceAndRewardsAggregateByDateRange = gql(/* GraphQL */ `
  query GetDelegatorBalanceAndRewardsAggregateByDateRangeQuery(
    $idSs58: String!
    $startDate: Datetime!
    $endDate: Datetime!
  ) {
    oldestSnapshot: allDelegationSnapshots(
      condition: { delegatorAccountIdSs58: $idSs58 }
      orderBy: [TIMESTAMP_ASC]
      first: 1
    ) {
      nodes {
        timestamp
      }
    }
    volumeSnapshots: allDelegationSnapshots(
      condition: { delegatorAccountIdSs58: $idSs58 }
      filter: { timestamp: { greaterThanOrEqualTo: $startDate, lessThanOrEqualTo: $endDate } }
      orderBy: [TIMESTAMP_ASC]
    ) {
      groupedAggregates(groupBy: TIMESTAMP_TRUNCATED_TO_DAY) {
        date: keys
        max {
          rewards
          rewardsValueUsd
          balance
          balanceValueUsd
        }
      }
    }
  }
`);
